export default "__VITE_ASSET__9jt3_CvF__"